import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import {
  getSupplierCreditApplicationsReport,
  getSupplierCustomerArReport,
  getSupplierReport,
  getCustomerAnalytics,
  getCreditManagerArPerformance,
  getCreditReviewerPerformance,
  getSupplierInvoiceCollectionNotesReport,
} from '../services/reportsService';
import { ReportsInitialState } from '../globalSlices/reportsSlice';

export const getSupplierReportExtraReducer = (
  builder: ActionReducerMapBuilder<ReportsInitialState>
) => {
  const reducerId = 'getSupplierReport';
  builder.addCase(getSupplierReport.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierReport.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      state.supplierAnnualReport = action.payload?.data;
    }
  );
  builder.addCase(getSupplierReport.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getSupplierCustomerArReportExtraReducer = (
  builder: ActionReducerMapBuilder<ReportsInitialState>
) => {
  const reducerId = 'getSupplierCustomerArReport';
  builder.addCase(getSupplierCustomerArReport.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierCustomerArReport.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(getSupplierCustomerArReport.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getSupplierCreditApplicationsReportExtraReducer = (
  builder: ActionReducerMapBuilder<ReportsInitialState>
) => {
  const reducerId = 'getSupplierCreditApplicationsReport';
  builder.addCase(getSupplierCreditApplicationsReport.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierCreditApplicationsReport.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      state.supplierCreditApplicationsAnnualReport = action.payload?.data;
    }
  );
  builder.addCase(
    getSupplierCreditApplicationsReport.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};
export const getCustomerAnalyticsExtraReducer = (
  builder: ActionReducerMapBuilder<ReportsInitialState>
) => {
  const reducerId = 'getCustomerAnalytics';
  builder.addCase(getCustomerAnalytics.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getCustomerAnalytics.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      state.customerAnalyticsReport = action.payload?.data;
    }
  );
  builder.addCase(getCustomerAnalytics.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getSupplierInvoiceCollectionNotesReportExtraReducer = (
  builder: ActionReducerMapBuilder<ReportsInitialState>
) => {
  const reducerId = 'getSupplierInvoiceCollectionNotesReport';
  builder.addCase(getSupplierInvoiceCollectionNotesReport.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierInvoiceCollectionNotesReport.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      state.invoiceCollectionNotesReport = action.payload?.data;
    }
  );
  builder.addCase(
    getSupplierInvoiceCollectionNotesReport.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};

export const getCreditManagerArPerformanceExtraReducer = (
  builder: ActionReducerMapBuilder<ReportsInitialState>
) => {
  const reducerId = 'getCreditManagerArPerformance';
  builder.addCase(getCreditManagerArPerformance.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getCreditManagerArPerformance.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      state.creditManagerArPerformanceReport = action.payload?.data;
    }
  );
  builder.addCase(getCreditManagerArPerformance.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getCreditReviewerPerformanceExtraReducer = (
  builder: ActionReducerMapBuilder<ReportsInitialState>
) => {
  const reducerId = 'getCreditReviewerPerformance';
  builder.addCase(getCreditReviewerPerformance.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getCreditReviewerPerformance.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      state.creditReviewerPerformanceReport = action.payload?.data;
    }
  );
  builder.addCase(getCreditReviewerPerformance.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
